import Loadable from 'app/components/Loadable';
import { AuthRoute } from 'app/routes';
import { lazy } from 'react';

const NotFound = Loadable(lazy(() => import('./NotFound')));
// const ForgotPassword = Loadable(lazy(() => import('./ForgotPassword')));
const JwtLogin = Loadable(lazy(() => import('./JwtLogin')));
// const ResetPassword = Loadable(lazy(() => import('./ResetPassword')));
// const VerifyEmail = Loadable(lazy(() => import('./VerifyEmail')));

const sessionRoutes: AuthRoute[] = [
  { path: '/session/signin', element: <JwtLogin /> },
  // { path: '/session/forgot-password', element: <ForgotPassword /> },
  // { path: '/session/reset-password/:token', element: <ResetPassword /> },
  // { path: '/session/verify-email/:token', element: <VerifyEmail /> },
  { path: '/session/404', element: <NotFound /> },
];

export default sessionRoutes;
